module.exports = __webpack_public_path__ + "img/locale3.62e5b12b.png";